module.exports = {"id":"177149","name":"Bojan Jokič","rating":"75","photo":"./data/images/photos/4/177149.png","club":{"name":"FK Oufa","logo":"./data/images/clubs/FKOufa.png"},"positions":["DLG","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BojanJokic0.json
// module id = 617
// module chunks = 0